var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext } from "@wordpress/element";
import { convertCommentFromServer } from "../../../utils/comment";
import { addTaskCommentRequest, addUserCommentRequest, getTaskCommentsRequest, getUserCommentsRequest, } from "../../api/user-page-api";
import { UserPageAppContext } from "../../providers/UserPageAppContextProvider";
import { useErrorHandler } from "../useErrorHandler";
function useCommentActions() {
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    const loadTaskComments = (pageHash, taskHash, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield getTaskCommentsRequest(pageHash, taskHash);
            if (callback)
                callback(response.data);
        }
        catch (error) {
            handleError(error);
        }
    });
    const addTaskComment = (taskHash, comment, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield addTaskCommentRequest(pageHash, taskHash, comment);
            const comments = response.data.map(convertCommentFromServer);
            if (callback)
                callback(comments);
        }
        catch (error) {
            handleError(error);
        }
    });
    const loadUserComments = (callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield getUserCommentsRequest(pageHash);
            const comments = response.data.map(convertCommentFromServer);
            callback(comments);
        }
        catch (error) {
            handleError(error);
        }
    });
    const addUserComment = (commentText, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield addUserCommentRequest(pageHash, commentText);
            const comments = response.data.map(convertCommentFromServer);
            callback(comments);
        }
        catch (error) {
            handleError(error);
        }
    });
    return { loadTaskComments, addTaskComment, loadUserComments, addUserComment };
}
export { useCommentActions };
